import isAbsolutePath from './is-absolute-path';
const checkIfUrlHasSameDomain = (domain, sanitizedUrl) => {
  if (!domain || !sanitizedUrl) return false;
  if (!isAbsolutePath(sanitizedUrl)) return true;
  const domainParts = domain.split('.');
  const rootDomain = domainParts.slice(-2).join('.');
  return sanitizedUrl.includes(rootDomain);
};
export default checkIfUrlHasSameDomain;
//# sourceMappingURL=check-if-url-has-same-domain.js.map